module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e2"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("Chapter 1 ")])]), _c('br'), _c('br'), _c('i', [_vm._v("The World of Autism")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e97410"
    }
  }, [_vm._v("Ten Things You Will Learn in This Chapter ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e97910"
    }
  }, [_vm._v("• What differentiates autism spectrum disorders")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e456"
    }
  }, [_vm._v("• The signs and symptoms of classical autism")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e458"
    }
  }, [_vm._v("• How to respond to echolalia")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e460"
    }
  }, [_vm._v("• The details of the Theory of Mind")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e462"
    }
  }, [_vm._v("• What exactly “conceptual thinking” means")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e464"
    }
  }, [_vm._v("• About the history and diagnosis of Asperger’s syndrome")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e466"
    }
  }, [_vm._v("• Which of the autism spectrum disorders have been confirmed as genetic")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e468"
    }
  }, [_vm._v("• What defines high-functioning autism")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e471"
    }
  }, [_vm._v("• The differences between autism and Asperger’s syndrome")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e473"
    }
  }, [_vm._v("• Possible causes of autism ")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e3"
    }
  }, [_c('b', [_vm._v("What Are Autism Spectrum Disorders?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e107311"
    }
  }, [_vm._v("Learning about autism spectrum disorders is a bit like learning an unfamiliar language. It is a new world, and the customs and behaviors may seem foreign. From the moment a physician gives the diagnosis, everything changes. In all likelihood, as a mom or dad, this will not be the parenting experience you had hoped for. There are pitfalls and disappointments along the way. However, the good news is that this world can be navigated successfully, and it can be the beginning of something different, full of adventure and accomplishment.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e111411"
    }
  }, [_vm._v("Often referred to as ASD, autism spectrum disorder is a broad classification of conditions sharing similar objective symptoms. Objective symptoms are those that can be observed by someone other than the patient, whereas subjective symptoms are those that only the patient experiences. For example, in the case of influenza, an objective symptom might be a fever or a rash; a subjective symptom might be fatigue or pain.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e114911"
    }
  }, [_vm._v("Many times ASD is referred to as PDD (pervasive developmental disorder). Historically, ASD has been the more commonly used term in Europe and has recently been accepted as the proper term in the United States as well. This differs from PDD-NOS, which will be discussed in more detail later in this chapter. All of the various conditions within the spectrum are labeled, and there are differences in how the various conditions manifest themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e4"
    }
  }, [_c('b', [_vm._v("Classical Autism ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e120512"
    }
  }, [_vm._v("Autism is the most commonly known of the spectrum disorders. First written about in the 1940s by Dr. Leo Kanner, a psychiatrist at Johns Hopkins University, autism was rarely seen by physicians. Characterized primarily by communication and socialization difficulties, classical autism is a very isolating and frustrating condition.")]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "d7e123812"
    }
  }, [_vm._v("DID YOU KNOW?")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e124512"
    }
  }, [_vm._v("The word autism originates from the Greek word autos, meaning “self.” This disorder was named "), _c('i', [_vm._v("autism")]), _vm._v(" because it was believed to be an excessive preoccupation with oneself, originating from a mother who would not love her child. This theory has been proved false, and"), _c('i', [_vm._v(" autism")]), _vm._v(" is now recognized as a medical disorder.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e128312"
    }
  }, [_vm._v("Classical autism is part of the ASD, or PDD, category. It is the best known of the pervasive development disorders, and it is one of the largest classifications within ASD as well, rivaled only by PDD-NOS (pervasive development disorder “not otherwise specified”). ASD is a syndrome. A syndrome is a group of symptoms that indicate a condition. Syndromes, by their very nature, have many characteristics, and each patient will display or not display those symptoms in very different ways. As such, each case of autism can be different.")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "d7e134913"
    }
  }, [_c('b', [_c('i', [_vm._v("The Signs and Symptoms of Autism ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e135413"
    }
  }, [_vm._v("Autism has a set of signs and symptoms that can appear differently in each child, and parents must remember that what is considered autistic in one child may not appear in another child who is also considered autistic. This is part of the time-consuming nature of the diagnosis of autism. Without a definitive lab test such as blood work, diagnosis is a process of defining and understanding the symptoms as displayed. As a rule, children with autism exhibit the following signs and symptoms that characterize all autism spectrum disorders to a great degree.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e139313"
    }
  }, [_vm._v("Expressive and receptive communication and social deficits Insistence on routine and resistance to change Appearing to be “off in their own little world”")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e510"
    }
  }, [_vm._v("• Expressive and receptive communication and\nsocial deficits")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e512"
    }
  }, [_vm._v("• Insistence on routine and resistance to change")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e514"
    }
  }, [_vm._v("• Appearing to be “off in their own little world”")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e516"
    }
  }, [_vm._v("• Resistance to physical closeness such as hugging")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e518"
    }
  }, [_vm._v("• Attachment to “odd” toys such as kitchen\nutensils")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e520"
    }
  }, [_vm._v("• Parallel play (playing beside other children\nrather than interactively with them) and lack of\nimaginative play")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e522"
    }
  }, [_vm._v("• Sudden and apparently unexplainable anger and\ntantrums")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e524"
    }
  }, [_vm._v("• Repetitive behaviors and obsessive-compulsive\ndisorder")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e527"
    }
  }, [_vm._v("• Splinter skills (excelling in a particular skill that\nis above the apparent IQ level)")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e529"
    }
  }, [_vm._v("• Appearing to have sensory overload in normal\nenvironments")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "d7e148914"
    }
  }, [_c('b', [_c('i', [_vm._v("The Struggle with Communication ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e149414"
    }
  }, [_vm._v("There is a marked reduction in verbal communication, or a child may have no speech at all. Echolalia is a speech pattern seen in autism spectrum disorders in which a child echoes back the words spoken to him or her. It is an attempt to understand language. For example, instead of responding to a question with an answer, the question is repeated back.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e152514"
    }
  }, [_vm._v("Children with autism also have difficulties with nonverbal communication skills. It is problematic for a child with autism to understand, use, and interpret subtle nonverbal language cues, such as facial expression or tone of voice, and translate those into meaningful language.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e154614"
    }
  }, [_vm._v("The difficulty with communication often accentuates the other deficits in autism. Frustration is a common problem with a child unable to communicate his most basic needs, and the result of frustration is often anger. A child will either struggle to communicate or withdraw even further if he is unable to convey thoughts and feelings to others.")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "d7e157514"
    }
  }, [_c('b', [_c('i', [_vm._v("The Problem with Conceptual Thinking ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e158014"
    }
  }, [_vm._v("Children with autism also struggle in a profound way with conceptual ideas and thought patterns. For example, a child with autism may associate leaving the house with putting on a coat. Now imagine that same child was outside without a coat on and the temperature dropped dramatically, and it began to snow. Although the child might have a coat with her, even in her hands, she will not put on the coat. Why not? She associates the coat with leaving the house, not with a solution to cold weather, and the concept of using the coat for protection is nonexistent.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e162315"
    }
  }, [_vm._v("Because of the difficulty the child has in understanding concepts, he or she becomes limited in many ways. The child does not recognize that other people have their own thoughts, feelings, attitudes, and beliefs, and the child becomes even more isolated. Much of the maturing process for children is based on conceptual thinking, and the inability to think conceptually adds to the communication difficulties of a child with autism.")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "d7e166115"
    }
  }, [_c('b', [_c('i', [_vm._v("The Theory of Mind (TOM) ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e166615"
    }
  }, [_vm._v("At some point in a child’s development, he becomes aware that he is an individual. More importantly, he realizes that other people are individuals as well. Unfortunately, this moment never comes for children with autism. People with autism are unable to understand that every individual has her own thoughts and perspectives on the world. It is part of the self-involvement typical of ASD. It causes social problems and communication difficulties, and she can come across as cold and unfeeling.")]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "d7e170415"
    }
  }, [_vm._v("DOES THIS SOUND LIKE YOUR CHILD ?")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e171115"
    }
  }, [_vm._v("People with autism experience all of the same emotions that others do. The difficulty comes from their inability to recognize those emotions in others and to express empathy for those emotions. Do not think if your child does not display feelings that she doesn’t have them. She does.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e173916"
    }
  }, [_vm._v("Theory of mind (TOM) is the ability to recognize that other people have their own thoughts and feelings. If the theory of mind is disrupted, it is not a sign of poor intellect or mental retardation. It seems to be related to language and social function; feelings are generally communicated through language and subtle social clues (such as facial expression and body language), and these are the primary areas that are deficient in autism and its related disorders.")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "d7e177116"
    }
  }, [_c('b', [_c('i', [_vm._v("Anger and Aggression ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e177616"
    }
  }, [_vm._v("Although not all children with autism display aggression, it is a very common symptom, and temper outbursts and outright tantrums are common. These can range from a brief explosion to a full-fledged meltdown. Children with autism may also strike out through hitting and/or biting as well as by destroying objects and possessions.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e180616"
    }
  }, [_vm._v("A child with autism throwing a temper tantrum is not a child acting “spoiled” or “bratty.” Unfortunately, parents of children with ASD hear these terms quite often. These behaviors are a symptom of a disorder, not a result of poor parenting skills.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e5"
    }
  }, [_c('b', [_vm._v("PDD-NOS—What Do Those Letters Mean?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e183816"
    }
  }, [_vm._v("PDD, as mentioned previously, stands for “pervasive developmental disorder.” NOS means “not otherwise specified.” In real-life terms, this means that the physicians know that the child’s disorder is within the pervasive development category or on the autism spectrum, but it does not neatly fit into any particular category. As such, it is classified as a PDD that has no further specification— it isn’t quite autism, isn’t quite Asperger’s, and isn’t quite CDD (childhood disintegrative disorder), or any other PDD.")]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "d7e190717"
    }
  }, [_vm._v("A BETTER PARENTING PRACTICE ")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e191817"
    }
  }, [_vm._v("If your child has been diagnosed with PDD, ask the physician why this diagnosis was given rather than autism or Asperger’s syndrome. A PDD diagnosis may stand between your child and benefits she is entitled to.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e194617"
    }
  }, [_vm._v("PDD-NOS has essentially the same set of signs and symptoms that autism does, but the severity of the symptoms is not as extreme as that found in autism. A child who has PDD-NOS may initiate speech, using language that is appropriate to the context of the social situation. There will be deficits compared to the milestones of normal childhood development; however, they will not be as blatant as a child who has autism. Echolalia is heard less often and auditory processing skills are more advanced.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e199717"
    }
  }, [_vm._v("Social skills in a PDD-NOS child are also less of a challenge. These children are able to interact to varying degrees with parents, siblings, other adults, and children. Imaginative play may still be limited but interactive play is somewhat more common than it is with a child who is autistic.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e6"
    }
  }, [_c('b', [_vm._v("Asperger’s Syndrome ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e204018"
    }
  }, [_vm._v("Dr. Hans Asperger first documented Asperger’s syndrome at the same time Dr. Kanner was writing about autism. Both physicians were unaware of the other’s work, as open communication between German and American scientists was not possible during World War II. The two physicians, however, arrived at the same conclusion at a time when ASD had not yet been officially identified. European physicians diagnosed Asperger’s syndrome, and American physicians diagnosed Kanner’s syndrome, which was the name initially given to autism.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e209918"
    }
  }, [_vm._v("It was not until the early 1980s that Asperger’s was brought into American diagnostic procedures, and it was a full decade later that Dr. Asperger’s original paper on the topic was translated into English. It was during the early 1990s that Asperger’s syndrome was placed on the autism spectrum and became a disorder independent of other spectrum disorders. Several signs distinguish Asperger’s syndrome from other disorders on the spectrum:")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e215218"
    }
  }, [_vm._v("• Essentially normal speech development with phrases used by age three")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e593"
    }
  }, [_vm._v("• Essentially normal cognitive development")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e595"
    }
  }, [_vm._v("• Essentially normal development in self-help and curiosity about the world")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e597"
    }
  }, [_vm._v("• Gross motor skills are often delayed and clumsiness is common ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e219319"
    }
  }, [_vm._v("• Eye contact, facial expression, body language inappropriate to the social situation")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e601"
    }
  }, [_vm._v("• Difficulty establishing and maintaining peer relationships ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e603"
    }
  }, [_vm._v("• Difficulty expressing emotions and relating to others with those emotions")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e606"
    }
  }, [_vm._v("• Intense and persistent association with particular subjects, objects, or topics")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e608"
    }
  }, [_vm._v("• Repetitive mannerisms such as flapping")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e610"
    }
  }, [_vm._v("• Insistence on routine ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e224519"
    }
  }, [_vm._v("Although the symptoms of Asperger’s syndrome seem very similar to that of autism, the normal development of speech and motor skill difficulties distinguish this disorder. Keeping in mind there are varying degrees of severity in Asperger’s, it becomes easier to understand why diagnosis of this particular form of a high-functioning ASD may be delayed for many years. There are adults who are just now receiving the diagnosis of Asperger’s, having been thought of as odd or eccentric for decades.")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "d7e229619"
    }
  }, [_c('b', [_c('i', [_vm._v("The Subtle Cues of Communication ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e230119"
    }
  }, [_vm._v("The most obvious symptom in Asperger’s syndrome is the socialization impairment. So much of our society’s communication is based on unspoken cues, such as hand gestures, body language, eye movement, and even the pauses in conversation. All of those convey emotions and messages that may be subtle, but they are crucial to understanding the meaning of what a person is saying. For a person with Asperger’s, those nonverbal cues are totally missed, as they live in a literal world where words have only literal meanings.")]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "d7e234920"
    }
  }, [_vm._v("DID YOU KNOW?")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e235620"
    }
  }, [_vm._v("It is common to hear people with Asperger’s syndrome refer to themselves as “Aspies.” This is not a derogatory term; however, it should be used only with someone who is close, such as a family member.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e238320"
    }
  }, [_vm._v("It is possible for people with Asperger’s to learn social mannerisms by rote, but they do not generally understand the meaning behind them, and consequently, socialization suffers. Often people will misunderstand what a person with Asperger’s is trying to say because of the literalness of the conversation. These misunderstandings can lead to hurt feelings and anger.")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "d7e242220"
    }
  }, [_c('b', [_c('i', [_vm._v("Asperger’s and Autism ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e243020"
    }
  }, [_vm._v("One challenge for parents is distinguishing Asperger’s syndrome from autism in a very young child. If the parents have no other children, they may not have a frame of reference for comparison, or they might not realize how disordered the structure of the Asperger’s social world is. In addition, if a child is very talkative and seems somewhat advanced in her interests, the parents may think the child is unusually gifted rather than narrowly and persistently focused on a subject, object, or topic.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e247521"
    }
  }, [_vm._v("It is important for the child to have an early diagnosis that is accurate so appropriate intervention can begin. Testing by qualified medical professionals can determine where a child falls on the autism spectrum and what treatments and therapies should be initiated. As with all disorders on the spectrum, early intervention offers the best hope for a promising future.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e7"
    }
  }, [_c('b', [_vm._v("High-Functioning Autism ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e251221"
    }
  }, [_vm._v("High-functioning autism (HFA) is a disorder on the autism spectrum that is often confused with Asperger’s syndrome. It is, however, a distinct disorder. There is controversy about HFA because of the standard used to separate it from classical autism.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e254021"
    }
  }, [_vm._v("Statistically, many experts feel that approximately 75 percent of children with autism are mentally retarded. The technical standard for determining high-functioning autism and classical autism is the presence of mental retardation. In the past, a child with autism who was retarded was considered to have classical autism, and if retardation was not present, the disorder on the spectrum was high-functioning autism. If your child has a diagnosis of autism, do not assume he or she is retarded, as this may be the furthest thing from the truth. This is a very gray area and extremely difficult to determine for children on the autism spectrum.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e258221"
    }
  }, [_vm._v("The reason that this is a hotly debated issue is because of the difficulty of accurately measuring IQ in nonverbal children, as tests are constructed so that verbalization and the ability to conceptualize are mandatory. If a person is nonverbal and is unable to understand concepts, they will fail miserably at this method of determining intelligence. A score of seventy or below on an IQ test indicates a person is mentally retarded. However, a child with autism may not be measured accurately with the standardized IQ testing. Many physicians feel that children are inaccurately labeled as being retarded, which makes the line between classical autism and high-functioning autism harder to determine.")]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "d7e263822"
    }
  }, [_vm._v("DOES THIS SOUND LIKE YOUR CHILD ?")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e264522"
    }
  }, [_vm._v("There are gender tendencies in autism spectrum disorders. Seventy-five percent of children with autism and PDD-NOS are boys. Asperger’s syndrome affects boys at a ratio of 10 to 1 over girls. Fragile X and childhood disintegrative disorder are also more prevalent in boys. The only ASD to affect girls almost exclusively is Rett syndrome.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e268922"
    }
  }, [_vm._v("In everyday life, for parents, teachers, and most medical professionals, high-functioning autism is autism that is less debilitating than classical autism. If spectrum disorders could be viewed on a scale, high-functioning autism would fall between classical autism and PDD-NOS. As stated before, there is a fine line between HFA and Asperger’s—the primary difference is in the motor skills. Although there are always exceptions, children with classical or high-functioning autism will not have the deficits in motor skills that a child with Asperger’s displays.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e8"
    }
  }, [_c('b', [_vm._v("Rett Syndrome and Other Spectrum Disorders ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e275623"
    }
  }, [_vm._v("This spectrum disorder is unique, as it affects girls almost exclusively. Until recently, it was thought that a male fetus could not survive the disorder, and therefore all victims were female. Research now shows that although Rett syndrome is rare in boys, it should not be excluded as a diagnosis just because of gender. Rett syndrome is a genetically caused disorder.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e279023"
    }
  }, [_vm._v("A gene mutation causes Rett syndrome, and the degree of the mutation determines the severity of the condition. If a boy does have Rett syndrome, he will display the symptoms differently than a classic Rett syndrome girl, and therefore DNA testing is required to determine this disorder in boys. Rett syndrome is a rare condition, affecting only 1 in 100,000 children. The diagnosis of Rett syndrome is made by the observation of symptoms similar to autism. However, the differences between the two conditions become more apparent as the child ages, due to the dramatic regression exhibited in Rett syndrome. Indicators of Rett syndrome include:")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e286223"
    }
  }, [_vm._v("• Frequent hand-wringing motion, which is unique to this disorder")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e660"
    }
  }, [_vm._v("• Major milestones as an infant achieved")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e662"
    }
  }, [_vm._v("• Loss of skills and abilities beginning at age two with increase in hand wringing")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e664"
    }
  }, [_vm._v("• Loss of the ability to walk")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e666"
    }
  }, [_vm._v("• Profound retardation")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e668"
    }
  }, [_vm._v("• Social skills decreasing with age ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e291224"
    }
  }, [_vm._v("Girls with Rett syndrome are often misdiagnosed as being autistic when they are very young because of the similarities of symptoms. It is as the child ages, between the ages of five and ten, that the differences become apparent. The distinctive hand wringing is indicative of the disorder, and it interferes with normal motor functioning.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e293924"
    }
  }, [_vm._v("There are other lesser-known disorders on the autism spectrum such as childhood disintegrative disorder, fragile X syndrome, auditory processing disorder, hyperlexia, Williams syndrome, Prader-Willi syndrome, and Landau-Kleffner syndrome. A handful of disorders seem to fall among the better-known disorders. Most of these disorders are characterized by some of the same symptoms as other disorders on the spectrum, but they are less severe in their number and/or intensity. Other disorders are rare and seldom diagnosed in the face of other, more accepted diagnoses.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e9"
    }
  }, [_c('b', [_vm._v("Implications of an ASD Diagnosis ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e299824"
    }
  }, [_vm._v("Actually receiving the diagnosis of a disorder on the autism spectrum is often the most difficult step you, as a parent, will encounter. Virtually all children with autism show the symptoms and can be diagnosed between the ages of two and four. The most common age for children to display the behaviors and traits of autism is between fifteen and twenty months. Although some children are born with certain qualities that cause their parents to take note and observe them for unusual behavior, it is most common for a child to develop normally up to about sixteen months and then begin to regress, losing skills that had been mastered. It is common for children with ASD to have normal speech and behavior patterns for a child of fifteen to twenty months and then lose that behavior and speech, retreating into a world that they alone occupy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e306725"
    }
  }, [_vm._v("However, the issue is not so much about at what age autism strikes as it is about getting an early diagnosis. A correct diagnosis for a child at a very young age means treatment and intervention at a very young age. Those interventions can make all the difference in a child’s future. If a child receives therapy and treatments beginning at approximately age two or three, the long-term outlook is much better.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e309625"
    }
  }, [_vm._v("Although each child will display his particular type of ASD in a unique way, there are symptoms that form a consistent basis upon which to diagnose the disorder. The different degrees of these symptoms will determine the particular diagnosis of which disorder it is.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e312325"
    }
  }, [_vm._v("The three main categories that characterize ASD are social interaction, communication, and patterns of behavior, interests, and activity. Within these three categories are four criteria that are then used to determine if the diagnosis of an ASD is appropriate. At least one of the signs within each category along with a minimum of six signs from all of the categories must be met for a diagnosis of ASD.")]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "d7e316526"
    }
  }, [_vm._v("DID YOU KNOW?")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e317226"
    }
  }, [_vm._v("The "), _c('i', [_vm._v("Diagnostic and Statistical Manual of Mental Disorders")]), _vm._v(", 4th edition, published by the American Psychiatric Association, is the manual used to diagnose autism spectrum disorders. In other words, whether a patient sees a physician in New York City or Cleveland, Ohio, the same standards are applied to diagnose a particular disorder.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e320626"
    }
  }, [_vm._v("Children with autism usually display the signs readily whereas pervasive developmental disorder, which is diagnosed with fewer than six signs, may be more elusive. The same symptoms exist but in a milder form. Sometimes parents need to seek out consultations with several experts to determine the exact diagnosis in less extreme cases.")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "d7e323626"
    }
  }, [_c('b', [_c('i', [_vm._v("Social Interaction ")])]), _vm._v("How a child interacts socially ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e324426"
    }
  }, [_vm._v("How a child interacts socially is the first of the three categories examined to ascertain whether an autism spectrum disorder is present. The physician will be involved, and it is likely a psychologist or psychiatrist may examine the child as well. Other experts will be consulted if needed. Doctors will look for ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e326626"
    }
  }, [_vm._v("•Reduction or absence of eye contact, facial expressions, and/or body language")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e704"
    }
  }, [_vm._v("• Inability to form friendships within a peer group x ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e328627"
    }
  }, [_vm._v("•Unwillingness or inability to share enjoyment or accomplishments with others")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e708"
    }
  }, [_vm._v("• Inability to relate and share emotions on a social level ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e330727"
    }
  }, [_vm._v("The impairment of social skills in a child with autism becomes obvious to a parent when a child is young. As a child matures, the interaction skills within the peer group isolate the child further, as he or she is unable to relate to other children and adults.")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "d7e332627"
    }
  }, [_c('b', [_c('i', [_vm._v("Communication ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e333127"
    }
  }, [_vm._v("Communication is the second area experts analyze to determine if autism or a related condition is present. This exam involves a physician, speech therapist, and possibly other experts such as a psychologist or psychiatrist. The communication difficulties in an ASD child are typical to most of the conditions on the spectrum. These include ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e336427"
    }
  }, [_vm._v("• Reduction, absence, or loss of expressive (spoken) language")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e721"
    }
  }, [_vm._v("• No attempt to replace language with another method of communication ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e723"
    }
  }, [_vm._v("•Inability to converse with another person even if speech is present")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e725"
    }
  }, [_vm._v("• Repetitive use of words, or echolalia (echoing words without meaning)")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e727"
    }
  }, [_vm._v("• Absence of imaginative play typical to a specific age group ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e341928"
    }
  }, [_vm._v("Communication is imperative for a human being to function successfully. This impairment may be the most blatant and painful for parents to understand and cope with on a day-to-day basis. A child may have had language at a young age, perhaps saying “mommy” or “daddy” or identifying various objects within the house, and then lose those words completely.")]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "d7e344528"
    }
  }, [_vm._v("DOES THIS SOUND LIKE YOUR CHILD ?")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e345228"
    }
  }, [_vm._v("The behaviors of autism may seem strange at first, but upon consideration, you will see that they reflect the child’s effort to establish predictability and order in his or her world. A world with limited language, or no language at all, is out of control. A repetitive behavior can help the child gain some control.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e347528"
    }
  }, [_vm._v("A child may be suspected of being deaf because of the total lack of response to spoken language. It is common for the diagnostic trail to begin with a parent or grandparent asking for an auditory test because of the child’s apparent lack of hearing. However, when the tests show that the child’s hearing is normal, further testing will lead to the ASD diagnosis.")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "d7e350628"
    }
  }, [_c('b', [_c('i', [_vm._v("Patterns of Behavior, Interests, or Activity ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e351228"
    }
  }, [_vm._v("The behaviors in a child with ASD are very distinctive and will be an indicator of where on the spectrum a child places. This exam involves a physician, possibly a pediatric neurologist, various therapists, and possibly experts in the mental health field. They will look for characteristics such as:")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e354429"
    }
  }, [_vm._v("•Intense preoccupation with a particular activity")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e746"
    }
  }, [_vm._v("• Compulsive engagement in routines that serve no practical function")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e748"
    }
  }, [_vm._v("• Repetitive movements such as flapping, spinning, and/or body movements")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d14e750"
    }
  }, [_vm._v("• Intense preoccupation with parts of a whole— for example, the spinning tires on a bicycle rather than the entire bicycle ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e358629"
    }
  }, [_vm._v("The behaviors of ASD are perhaps the best known of the signs and symptoms. Most children with autism appear perfectly normal to the bystander until certain behaviors such as flapping or spinning indicate that autism or a related condition is present. These behaviors are an early indicator as well, and they may be what prompt parents to seek a medical opinion.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e10"
    }
  }, [_c('b', [_vm._v("Why the Increase in Incidence?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e362429"
    }
  }, [_vm._v("Over the past few years, there has been considerable debate regarding statistics that show an increase in the number of children diagnosed as autistic or on the spectrum. Has the number of children with autism increased, or has better diagnostic criteria resulted in the appearance of a higher incidence? This question has the autism community divided.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e365129"
    }
  }, [_vm._v("Autism was documented for the first time in the 1940s and it was theorized that “refrigerator mothers,” those mothers who withheld love from their children, were causing autism. Because of that, it was labeled a psychiatric disorder and 50 percent of diagnosed children were institutionalized, forgotten by a society that never knew them in the first place.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e368630"
    }
  }, [_vm._v("Thirty years ago, the incidence of autism was between 1 and 4 per 10,000 children. It was a rare disorder, and few people had ever heard of it. In the recent past, though, the number of children with autism has exploded. It is difficult to find exact statistics on autism, but estimates by some research organizations show that it affects anywhere from 1 or 2 children per 500 to 1 per 100. The CDC reports a range of 2 to 6 per 1,000 children. The CDC reported that during the 2000– 2001 school year, there were more than 15,000 children ages three to five years old and more than 78,000 children ages six to twenty-one years old in the United States with autism, as defined in the Individuals with Disabilities Education Act (IDEA). These estimated numbers are lower than the actual count, however, as students in private schools or homeschooling environments are not included.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e375830"
    }
  }, [_vm._v("The question remains whether the numbers are a true reflection of an increase of actual children with an ASD or if the procedures for diagnosis are simply more accurate now. Could it just be that it is recognized and properly labeled more often because our society has become better educated and more aware of autism and related conditions? Were children who had autism thirty years ago overlooked and therefore not treated? Many parents and researchers find themselves at odds over this point, and the children are in the middle of the debate.")]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "d7e380831"
    }
  }, [_vm._v("DID YOU KNOW?")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e381531"
    }
  }, [_vm._v("“Medicine for Autism Today,” a neuro-immune dysfunction syndrome (NIDS) project, documented a study that illustrated the dramatic rise in the number of children with autism when they reported a 900 percent increase in cases of autism. Autism, according to this study, is growing faster than any other special-needs disorder in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e385131"
    }
  }, [_vm._v("The unanswered question that essentially solves the debate pertains to adults. If autism has not increased in numbers and it is simply being diagnosed more carefully and accurately now, where are all of the adults with autism who were undiagnosed as children? Where are the children with autism who were born forty and fifty years ago?")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e11"
    }
  }, [_c('b', [_vm._v("A Look into Possible Causes ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e388531"
    }
  }, [_vm._v("Nothing divides the autism community more deeply than a discussion of the potential causes of autism. Perfectly normal and rational adults will come together in meetings and benefits to raise awareness of autism issues and end up in bitter arguments as to what causes autism. The conflicts over vaccinations, genetics, disease processes, and allergies—to name a few—have driven deeply into the consciousness of parents with affected children. Many feel there is no one single cause but that a combination of triggers, combined in a unique way during this generation, has caused a cascade effect that has resulted in the condition we call autism and its related disorders.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e393432"
    }
  }, [_vm._v("There is no one proven cause of autism, but there are many suspected triggers. Aggressive research continues to be done in an effort to determine what the cause may be so that the most effective intervention can be put in place.")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "d7e395432"
    }
  }, [_c('b', [_c('i', [_vm._v("Neuro-Immune Dysfunction Syndrome (NIDS)/ ")])]), _c('br'), _c('b', [_c('i', [_vm._v("Autoimmune Disease ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e396732"
    }
  }, [_vm._v("Interestingly enough, when the number of autism spectrum disorders in the population began to increase, so did the incidences of autoimmune diseases and chronic fatigue syndrome (CFS), as well as attention deficit disorder (ADD/ADHD). It is common to find a family in which one parent suffers from CFS or another autoimmune disorder, an older child has ADD, and a younger child falls somewhere on the autism spectrum. It is as if something came into the environment of the house and attacked, affecting each member of the family differently based on his or her age.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e401932"
    }
  }, [_vm._v("The NIDS theory says that many, if not most, patients who suffer from a variety of autoimmune disorders, as well as autism, actually have a neuro-immune dysfunction. This causes chemical imbalances, which subsequently causes a restriction in the blood flow to the brain. In autism, the area of the brain affected would be the area controlling speech, language, socialization, and obsessive behaviors. The trigger that starts the disease process could be environmental, vaccine-related, or an illness.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e406533"
    }
  }, [_vm._v("If this theory holds true, then what is being dealt with is a new disease that has a great potential for treatment. This theory has not been proven, but physicians researching NIDS and the treatment of it are seeing relief of the symptoms of autism in their patients. Parents who have chosen these methods of treatment for their children are also seeing improvements they had only hoped for but never expected.")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "d7e410233"
    }
  }, [_c('b', [_c('i', [_vm._v("Vaccinations ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e410733"
    }
  }, [_vm._v("One of the leading theories behind the cause of autism spectrum disorders is the increase in the number and kinds of vaccinations given to very young children. The leading suspect is the MMR (measles, mumps, and rubella) vaccination first given at approximately twelve to fifteen months of age. One study showed that upon biopsy of the lower gastrointestinal tract of children with autism, measles was found. This, of course, is not normal, and because many children with autism also have bowel diseases, it raised the question of what the connection may be. The study by Dr. Andrew Wakefield was later withdrawn though, and no link between the MMR vaccine and autism has been found.")]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "d7e417934"
    }
  }, [_vm._v("A BETTER PARENTING PRACTICE ")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e419034"
    }
  }, [_vm._v("If you choose not to have your child immunized, upon entering school, you will need paperwork that states one of two reasons. You may claim a religious exemption or present a letter from your child’s physician stating that he or she believes vaccinations are harmful to your child’s health.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e421734"
    }
  }, [_vm._v("The research continues, and in the interim, many parents have decided against immunizations, despite the insistence of health organizations that there is no link between the MMR and autism. There are thousands of anecdotal stories about children who were perfectly normal until shortly after the first MMR immunization. These children spoke in phrases, interacted with people around them, and suddenly became nonverbal and nonresponsive within a few days of receiving the immunization.")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "d7e426334"
    }
  }, [_c('b', [_c('i', [_vm._v("Genetics ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e426834"
    }
  }, [_vm._v("Many people believe that the cause of autism spectrum disorders will be found to have a genetic basis. Since many families who have one child with autism later have another one, it has led many to believe that autism “runs” in families. The only autism spectrum disorders that have been proven conclusively to be genetic are fragile X syndrome and Rett syndrome. Both of those disorders can be tested by blood work that looks directly at the chromosomes involved, and the genetic flaw can be identified.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e431335"
    }
  }, [_vm._v("The one hole in the theory that all autism spectrum disorders are genetic is that human genetics have not mutated very much over the past few thousand years, yet the incidence of autism is much higher now than at any time in history. Spontaneous gene mutations, which are especially more common in older parents, offer a newer genetic theory though.")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "d7e433935"
    }
  }, [_c('b', [_c('i', [_vm._v("Environmental Causes ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e434435"
    }
  }, [_vm._v("Another theory that either stands alone or works in conjunction with the other theories is that environmental issues may have caused autism. The world is now inundated with pollution, food processing, and other toxic elements that were not present in past eras. It is conceivable that humanity has caused this syndrome by environmental abuse.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e437035"
    }
  }, [_vm._v("The most likely link with the environment intertwines with other theories, such as environmental factors combining with a vaccine and affecting DNA in a new way. At this time, like all theories, the truth is unknown.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e435f9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tilt_ISBN9781598696769_epub_c7_r1.vue
// module id = 75
// module chunks = 0